'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _linksoftAlbatros = require('linksoft-albatros');

var _actions = require('../actions.js');

var _actions2 = _interopRequireDefault(_actions);

var _addToCart = require('../components/add-to-cart');

var _addToCart2 = _interopRequireDefault(_addToCart);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _has = require('lodash/has');

var _has2 = _interopRequireDefault(_has);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddToCartContainer = function (_React$Component) {
    (0, _inherits3.default)(AddToCartContainer, _React$Component);

    function AddToCartContainer() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, AddToCartContainer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AddToCartContainer.__proto__ || (0, _getPrototypeOf2.default)(AddToCartContainer)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (e) {
            _this.props.changeAmount({
                productId: _this.props.productId,
                amount: e.target.value || 0,
                origAmount: _this.props.origAmount,
                customerId: _this.props.customerId,
                finalPrice: _this.props.price,
                productName: _this.props.productName,
                authors: _this.props.authors,
                commission: _this.props.commission
            });
        }, _this.handleSubmit = function () {
            _this.props.submitChanges({
                productId: _this.props.productId,
                amount: _this.props.amount || 0,
                customerId: _this.props.customerId,
                price: _this.props.price,
                productName: _this.props.productName,
                authors: _this.props.authors,
                commission: _this.props.commission
            }, !_this.props.customerId, { miniCart: false });
        }, _this.handleProcessing = function () {
            // this disable scrolling
            // need it for perfect starting position of "flying pseudo cart"
            (0, _jquery2.default)('body').on('scroll touchmove mousewheel', function (e) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            });

            // make scroll enable again
            setTimeout(function () {
                (0, _jquery2.default)('body').off('scroll touchmove mousewheel');
            }, 1000);
        }, _this.handleProcessingComplete = function (e) {

            var id = e.inputId,
                ele = '.cartMenu .fa-shopping-basket',
                eleAlt = '.fa-shopping-cart',
                thisInput = document.getElementById(id),
                thisButton = thisInput.nextElementSibling,
                thisButtonTop = (0, _jquery2.default)(thisButton).offset().top - (0, _jquery2.default)(window).scrollTop() + 8,
                thisButtonLeft = (0, _jquery2.default)(thisButton).offset().left + 11,
                transitionEnd = 'webkitTransitionEnd mozTransitionEnd MSTransitionEnd otransitionend transitionend',
                animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend',
                isGoodsInStock = !!(0, _jquery2.default)(thisInput).closest('#goods.tab-pane').length;

            var targetPosTop = void 0,
                targetPosLeft = void 0;
            // eleAlt - alternative for cases, where is no shopping basket, but there is na cart element (cart page)
            var targetPos = (0, _jquery2.default)(ele).offset() || (0, _jquery2.default)(eleAlt).offset();

            if (!isGoodsInStock && targetPos) {
                targetPosTop = targetPos.top - (0, _jquery2.default)(window).scrollTop();
                targetPosLeft = targetPos.left;
            } else if (targetPos = (0, _jquery2.default)(thisInput).closest('tr').find('td:first-child').offset()) {
                targetPosTop = thisButtonTop;
                targetPosLeft = targetPos.left;
            }
            // case when there is no element to stick animation to, so no animation performed
            else return;

            (0, _jquery2.default)('body').append('<i id="pseudo-' + id + '" class="fa fa-shopping-basket pseudo-cart"></i>');
            var thisPseudoCart = (0, _jquery2.default)('#pseudo-' + id);

            thisPseudoCart.css({
                top: thisButtonTop,
                left: thisButtonLeft
            });

            setTimeout(function () {
                thisPseudoCart.css({
                    top: targetPosTop + 'px',
                    left: targetPosLeft + 'px'
                });
            }, 200);

            (0, _jquery2.default)('.pseudo-cart').one(transitionEnd, function () {
                (0, _jquery2.default)('.pseudo-cart').remove();

                if (!isGoodsInStock) {
                    (0, _jquery2.default)('.cartRespons, .cartRespons + .fa').addClass('animated bounceIn');
                }
            });

            (0, _jquery2.default)('.cartRespons, .cartRespons + .fa').one(animationEnd, function () {
                (0, _jquery2.default)('.cartRespons, .cartRespons + .fa').removeClass('animated bounceIn');
            });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(AddToCartContainer, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_addToCart2.default, (0, _extends3.default)({ onChange: this.handleChange,
                onSubmit: this.handleSubmit,
                onProcessing: this.handleProcessing,
                onProcessingComplete: this.handleProcessingComplete,
                canChangeCart: this.canChangeCart
            }, this.props));
        }
    }]);
    return AddToCartContainer;
}(_react2.default.Component);

AddToCartContainer.propTypes = {
    amount: _propTypes2.default.number,
    displayAmount: _propTypes2.default.string,
    productId: _propTypes2.default.number.isRequired,
    hasChanged: _propTypes2.default.bool.isRequired,
    processing: _propTypes2.default.bool.isRequired,
    amountAvailable: _propTypes2.default.number,
    totalAmountAvailable: _propTypes2.default.number,
    changeAmount: _propTypes2.default.func.isRequired,
    submitChanges: _propTypes2.default.func.isRequired,
    changedProductId: _propTypes2.default.number,
    productName: _propTypes2.default.string.isRequired,
    authors: _propTypes2.default.string.isRequired,
    commission: _propTypes2.default.bool
};

function mapStateToProps(state, ownProps) {
    var productId = ownProps.productId,
        customerId = ownProps.customerId,
        amount = ownProps.amount,
        _ownProps$amountAvail = ownProps.amountAvailable,
        amountAvailable = _ownProps$amountAvail === undefined ? 0 : _ownProps$amountAvail,
        _ownProps$totalAmount = ownProps.totalAmountAvailable,
        totalAmountAvailable = _ownProps$totalAmount === undefined ? 0 : _ownProps$totalAmount,
        productName = ownProps.productName,
        authors = ownProps.authors,
        commission = ownProps.commission;

    var props = {
        productId: productId,
        customerId: customerId,
        amount: null,
        amountAvailable: amountAvailable,
        totalAmountAvailable: totalAmountAvailable,
        origAmount: amount,
        hasChanged: false,
        processing: false,
        canChangeCart: state.cart.canChangeCart,
        changedProductId: state.cart.changedProductId,
        productName: productName,
        authors: authors,
        commission: commission
    };
    var changed = state.cart.changes[(0, _linksoftAlbatros.getCartChangeKey)(props)];
    if (changed) {
        props.hasChanged = true;
        props.amount = changed.amount;
        props.displayAmount = changed.displayAmount;
        props.processing = changed.processing;
    } else if (customerId) {
        var propPath = 'customerSpecific[' + productId + '][' + customerId + ']';
        props.amount = (0, _has2.default)(state.cart, propPath) ? (0, _get3.default)(state.cart, propPath) : amount;
        props.displayAmount = props.amount > 0 ? props.amount + '' : '';
    } else {
        var itemAmountElement = state.cart.itemAmounts.find(function (i) {
            return i.productId === productId;
        });
        if (itemAmountElement) {
            props.amount = itemAmountElement.amount;
            props.displayAmount = props.amount > 0 ? props.amount + '' : '';
        }
        var item = state.cart.items.find(function (i) {
            return i.productId === productId;
        });
        if (item) {
            props.productName = item.productName;
            props.authors = item.authors;
            props.commission = item.commission;
        }
    }
    return props;
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
    changeAmount: _actions2.default.changeAmount,
    submitChanges: _actions2.default.submitChanges
})(AddToCartContainer);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/containers/add-to-cart.js
// module id = 907
// module chunks = 0